import React from 'react'
import { notification, Modal } from 'antd'
import store from 'store'
import i18n from 'i18n'

import { getInitialAvatar, errorBase } from 'utils/ui'

import { history, store as reduxStore } from 'index'
import { setEnvParam, getEnvParam, removeEnvParam } from 'env'

import { verifyOtpCode } from 'services/admin-otp'

import { updateOnBoarding } from 'pages/provisioning/helper'

import mailApi from 'services/mailApi'

import { restLandingClient, mailAdminClient } from 'myNet'
import { updateAccountInfo } from 'pUtils'

import dataMgr from 'pages/chat/component/chatView/data/dataManager'

import { getMyInfo, getWorkspaceInfo } from './api'

const appConfigMap = {}
const tmpMap = {}

export function appConfig(email, forceOfficemail) {
  const promise = new Promise((resolve, reject) => {
    const info = {}

    const landingOfficemail = () => {
      const landingType = 'officemail'

      restLandingClient
        .get(`/auth/landing/${landingType}`, {
          type: 'console',
          schema: 'web',
          email,
        })
        .then((landingRes) => {
          console.log('landing - ', landingType, landingRes)
          // 처리~!!
          if (landingRes.data.code === 200) {
            info.authUrl = landingRes.data.data.auth_url
            resolve(info)
          } else {
            reject(new Error('landing error.'))
          }
        })
    }

    if (forceOfficemail !== true) {
      restLandingClient
        .post('/provisioning/appconfig', {
          email,
        })
        .then((res) => {
          console.log(' res - ', res)
          const { data } = res
          if (data.code === 200) {
            const appconfigs = data.data.appconfig
            if (appconfigs.length > 0) {
              const [appconfig] = appconfigs

              const { officenext, AppAuthenticationMethod, AppEmailServiceProvider } = appconfig

              appConfigMap[email] = appconfig

              info.officenext = officenext
              info.auth = AppAuthenticationMethod.toLowerCase()
              info.provider = AppEmailServiceProvider.toLowerCase()
              info.useOTP = false

              if (appconfig.officenext === true) {
                landingOfficemail()
              } else {
                // officenext가 아니면 모조리 otp.
                info.useOTP = true
                resolve(info)
              }
            } else {
              reject(new Error('appconfig error.'))
            }
          } else if (data.message != null) {
            // notification.warning({
            //   message: data.code,
            //   description: data.message,
            // })
            reject(new Error(data.message))
          }
        })
        .catch((err) => {
          console.log(' err - ', err)
          reject(err)
        })
    } else {
      landingOfficemail()
    }
  })

  return promise
}

export function landingWithoutPopup(email) {
  const promise = new Promise((resolve, reject) => {
    const info = {}
    const landingType = 'officemail'

    restLandingClient
      .get(`/auth/landing/${landingType}`, {
        type: 'console',
        schema: 'jiran',
        email,
      })
      .then((landingRes) => {
        console.log('landing - ', landingType, landingRes)
        // 처리~!!
        if (landingRes.data.code === 200) {
          info.authUrl = landingRes.data.data.auth_url
          resolve(info)
        } else {
          reject(new Error('landing error.'))
        }
      })
  })

  return promise
}

export function tmpValue(key) {
  return tmpMap[key]
}

const warning = (options) => {
  const props = {
    title: options.title,
    content: options.content,
    width: 450,
  }

  if (options.icon !== undefined) {
    props.icon = options.icon
  }

  return errorBase(props)
}

export function openLandingPopup(smallSize) {
  const windowSize = {
    width: 500,
    height: 600,
  }
  const windowLocation = {
    left: window.screen.availLeft + window.screen.availWidth / 2 - windowSize.width / 2,
    top: window.screen.availTop + window.screen.availHeight / 2 - windowSize.height / 2,
  }

  const options =
    smallSize !== true
      ? `width=${windowSize.width},height=${windowSize.height},left=${windowLocation.left},top=${windowLocation.top}`
      : `width=${10},height=${10},left=${windowLocation.left},top=${windowLocation.top}`

  const winName = `landingWin`

  window.loginWin = window.open('', winName, options)

  if (window.loginWin == null) {
    warning({
      title: i18n.t('common.title.blockPopup'),
      content: i18n.t('common.warning.blockPopup'),
    })

    reduxStore.dispatch({
      type: 'user/LOGOUT',
    })

    return false
  }

  return true
}

export function startLanding(email, authUrl) {
  const promise = new Promise((resolve, reject) => {
    const onSuccessLanding = (e) => {
      console.log(' -- message : ', e)

      if (
        window.location.origin === e.origin ||
        (e.origin.indexOf('rework.so') < 0 && e.origin.indexOf('officemail.io') < 0)
      ) {
        return
      }

      const data = typeof e.data === 'string' ? JSON.parse(e.data) : e.data

      try {
        if (window.loginWin != null) {
          clearInterval(window.loginTimer)
          window.loginWin.close()
          window.loginWin = null
        }
      } catch (err) {
        console.log(err)
      }

      if (data.params.result === 'OK') {
        console.log(' -- params : ', data.params)

        setEnvParam('userEmail', data.params.email)

        window.removeEventListener('message', onSuccessLanding)
        resolve(data.params.verify_string)
      } else if (data.error != null) {
        console.log(' --- login error ', data)
        const { code, message } = data.params
        const error = new Error(message)
        error.code = code
        window.removeEventListener('message', onSuccessLanding)
        reject(error)
      } else {
        reject(new Error('message parameter error.'))
      }
    }

    window.addEventListener('message', onSuccessLanding, false)

    try {
      const windowSize = {
        width: 500,
        height: 600,
      }
      // const windowLocation = {
      //   left: window.screen.availLeft + window.screen.availWidth / 2 - windowSize.width / 2,
      //   top: window.screen.availTop + window.screen.availHeight / 2 - windowSize.height / 2,
      // }

      // window.loginChatWin.moveTo(windowLocation.left, windowLocation.top);
      window.loginWin.resizeTo(windowSize.width, windowSize.height)
    } catch (e) {
      console.log('resize fail.', e)
    }

    window.loginWin.location.href = authUrl

    window.loginTimer = setInterval(() => {
      if (window.loginWin.closed) {
        clearInterval(window.loginTimer)

        reduxStore.dispatch({
          type: 'user/LOGOUT',
        })
      }
    }, 1000)
  })

  return promise
}

// async function loginIMAP(email, password) {
//   const promise = new Promise((resolve, reject) => {
//     const autoDiscoverRes = getEnvParam('providerInfo')

//     const params = {
//       host: autoDiscoverRes.incomingServer.hostname,
//       port: autoDiscoverRes.incomingServer.port,
//       email,
//       password,
//     }

//     restLandingClient
//       .post(`/auth/verifying/imap`, params)
//       .then((res) => {
//         console.log('data - ', res.data)

//         if (res.data.code === 200) {
//           setEnvParam('userEmail', email)

//           // authRegister(email)
//           //   .then((res2) => {
//           //     resolve(res2)
//           //   })
//           //   .catch((err) => {
//           //     reject(err)
//           //   })
//         } else if (res.data.code === 401) {
//           errorBase({
//             title: null,
//             content: i18n.t('login.error.emailOrPwInvalid'),
//           });
//         } else if (res.data.code === 500 || res.data.code === 504) {
//           errorBase({
//             title: i18n.t('login.error.internalError'),
//             content: i18n.t('login.error.retry'),
//           });
//           // notification.warning({
//           //   message: res.data.code,
//           //   description: res.data.message,
//           // })
//         } else {
//           reject(new Error('login failed'))
//         }
//       })
//       .catch((error) => {
//         console.log('error - ', error)
//         errorBase({
//           title: error.code,
//           content: error.message,
//         });
//         // notification.warning({
//         //   message: error.code,
//         //   description: error.message,
//         // })
//         reject(error)
//       })
//   })

//   return promise
// }

export async function login(email, password) {
  console.log(' login - ', email, password)
  // if (password != null) {
  //   return loginIMAP(email, password)
  // }

  return null
}

export async function loginByOTP(email, loginCode) {
  const promise = new Promise((resolve) => {
    verifyOtpCode(email, loginCode)
      .then((res) => {
        const { data } = res
        console.log('data - ', data)

        if (data.code === 200) {
          // token 저장하고
          if (data.workspace_id != null) {
            store.set('app.user.workspace_id', data.workspace_id)
          } else if (appConfigMap[email] != null && appConfigMap[email].workspace_id != null) {
            store.set('app.user.workspace_id', appConfigMap[email].workspace_id)
          }

          if (data.access_token != null) {
            store.set('app.user.token', data.access_token)
          }

          if (data.refresh_token != null) {
            store.set('app.user.refreshToken', data.refresh_token)
          }

          resolve(true)
        } else {
          if (data.code === 401) {
            errorBase({
              title: null,
              content: i18n.t('login.error.emailOrPwInvalid'),
            })
          } else if (data.code === 500 || data.code === 504) {
            errorBase({
              title: i18n.t('login.error.internalError'),
              content: i18n.t('login.error.retry'),
            })
          } else {
            // reject(new Error('login failed'))
            errorBase({
              title: 'Error',
              content: 'login failed',
            })
          }
          resolve(false)
        }
      })
      .catch((error) => {
        console.log('error - ', error)
        const errMsg = typeof error === 'string' ? error : error?.message

        if (errMsg?.includes('Not correct OTP')) {
          errorBase({
            title: i18n.t('login.error.notCorrectOTP'),
            // content: error.message,
          })
        }
        // notification.warning({
        //   message: error.code,
        //   description: error.message,
        // })
        resolve(false)
      })
  })

  return promise
}

export async function loginByKey(key) {
  const promise = new Promise((resolve) => {
    restLandingClient
      .get(`/auth/login/console/${key}`)
      .then((res) => {
        const { data } = res
        console.log('data - ', data)

        if (res.data.code === 200) {
          // token 저장하고
          store.set('app.user.workspace_id', data.data.workspace_id)

          if (data.data.access_token != null) {
            store.set('app.user.token', data.data.access_token)
          }

          if (data.data.refresh_token != null) {
            store.set('app.user.refreshToken', data.data.refresh_token)
          }

          if (data.data.provisioning === true) {
            store.set('app.user.provisioning', data.data.provisioning) // 이후에 이 값이 있으면 provisioning 페이지로 이동해야 함.
          } else {
            store.remove('app.user.provisioning') // 이후에 이 값이 있으면 provisioning 페이지로 이동해야 함.
          }

          // provisioning 페이지에서 이 값이 undefined이면 다시 로그인을 해야 함.
          tmpMap.provisioning = data.data.provisioning === true

          if (data.data.officenext != null) {
            // package 정보 - free, pro
            store.set('app.user.officenext', data.data.officenext)
          } else {
            store.remove('app.user.officenext')
          }

          resolve('success')
        } else {
          if (res.data.code === 401) {
            errorBase({
              title: null,
              content: i18n.t('login.error.emailOrPwInvalid'),
            })
          } else if (res.data.code === 500 || res.data.code === 504) {
            errorBase({
              title: i18n.t('login.error.internalError'),
              content: i18n.t('login.error.retry'),
            })
          } else {
            // reject(new Error('login failed'))
            errorBase({
              title: 'Error',
              content: 'login failed',
            })
          }
          resolve('fail')
        }
      })
      .catch((error) => {
        console.log('error - ', error)
        errorBase({
          title: error.code,
          content: error.message,
        })
        // notification.warning({
        //   message: error.code,
        //   description: error.message,
        // })
        resolve('fail')
      })
  })

  return promise
}

export async function register(/* email, password, name */) {
  function fakeRegister() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(true)
      }, 200)
    })
  }

  return fakeRegister()
}

export async function currentAccount() {
  const workspaceId = store.get('app.user.workspace_id')
  // const deviceUUID = store.get('app.user.deviceUUID');

  const { pathname } = window.location
  if (pathname.indexOf('/provisioning') === 0 && tmpValue('provisioning') === undefined) {
    if (pathname !== '/provisioning' && pathname !== '/provisioning/deleteDomain') {
      window.location.href = '/provisioning'
      return null
    }
  }

  const token = store.get('app.user.token')

  if (workspaceId == null || token == null) {
    reduxStore.dispatch({
      type: 'user/LOGOUT',
    })
    return null
  }

  let user = null
  const providerToken = store.get('app.user.providerToken')
  if (providerToken && providerToken.length > 0) {
    const mailApiInstance = mailApi.init()

    if (mailApiInstance == null) {
      // provider 가 없는 상태. 오류임.
      reduxStore.dispatch({
        type: 'user/LOGOUT',
      })

      return null
    }

    user = await mailApi.getCurrentAccount()
  }

  if (user != null) {
    // selectWorkspace(user.mail, () => {
    //   console.log('test');
    // })

    const email = user.mail || user.userPrincipalName || ''

    // login한 직후에만 존재하는 정보임. 로그인에 사용한 이메일 주소와 office에서 받은 이메일이 같은지 확인이 필요.
    const loginEmail = getEnvParam('userEmail')

    // const loginEmail = store.get('app.user.email')

    setEnvParam('userEmail', email)

    if (loginEmail != null && loginEmail !== email) {
      console.log(' email is different from login email.', loginEmail, email)
      setEnvParam('userEmail', loginEmail)

      const errorTxt = i18n.t('login.error.emailInfoInvalid')
      const config = {
        title: 'Error',
        content: <div dangerouslySetInnerHTML={{ __html: errorTxt }} />,
      }

      Modal.error(config)

      reduxStore.dispatch({
        type: 'user/LOGOUT',
      })
      return null
    }
  }

  const myInfo = await getMyInfo()

  let displayName = myInfo.display_name

  // displayName이 정의되지 않은 경우. 기본값을 설정한다.
  if (myInfo.display_name == null || myInfo.display_name.trim().length === 0) {
    if (user != null && user.displayName != null && user.displayName.length > 0) {
      displayName = user.displayName
    } else {
      const pos = myInfo.email.indexOf('@')
      displayName = myInfo.email.substring(0, pos)
    }

    await updateAccountInfo(myInfo.id, { displayName }, null, true)
  }

  setEnvParam('userEmail', myInfo.email)

  // startWS()

  // firebase 처리.
  /* @todo - 2달(?) 이상 넘어가면 토큰이 만료됨. 이에 대한 처리는? 일단 놔두자. 로그인할 때 다시 발급함. */
  // const fcmTokenTime = store.get('app.user.fcmToken_date')

  // if (fcmTokenTime == null || fcmTokenTime.length === 0) {
  //   getMessagingToken()
  // } else {
  //   const curTime = moment()
  //   const prevTime = moment(fcmTokenTime)
  //   const diffDay = curTime.diff(prevTime, 'days', true)

  //   // const username = myInfo.display_name != null ? myInfo.display_name : myInfo.email
  //   if (diffDay > 30) {
  //     updateDevice(myInfo.email)
  //   } else {
  //     const prevFcmToken = store.get('app.user.fcmToken')
  //     updateDevice(myInfo.email, prevFcmToken)
  //   }
  // }

  // const res = await getWorkspaceList()

  // console.log('myInfo - ', myInfo, res.data.workspace_list)

  // const workspace = res.data.workspace_list.find((item) => {
  //   if (item.workspace_id === workspaceId) {
  //     return true
  //   }
  //   return false
  // })

  // const workspaceStr = store.get('app.user.workspace')

  // const workspace =
  //   workspaceStr != null ? JSON.parse(workspaceStr) : { workspace_id: workspaceId }
  let workspaceInfo = null

  try {
    workspaceInfo = await getWorkspaceInfo(workspaceId)
  } catch (e) {
    console.log(' - getWorkspaceInfo error : ', e)
    notification.error({
      message: e.code,
      description: e.message,
    })
    reduxStore.dispatch({
      type: 'user/LOGOUT',
    })
    return null
  }

  const isOfficenext = store.get('app.user.officenext') != null
  // const provisioning = store.get('app.user.provisioning');

  let domainInfo = null
  const { onboarding, allowedDomain, provisioning } = workspaceInfo
  if (
    provisioning !== true
    // && provider != null && provider.toLowerCase() === 'officemail'
  ) {
    const domain = allowedDomain
    let needReture = false
    if (domain == null || domain.trim().length === 0) {
      // const mailObj = emailAddress(myInfo.email);
      // domain = (mailObj != null && mailObj.host != null) ? mailObj.host : '';
      // allowedDomain 값이 없으면 Onboarding을 페이지로 이동해야 함.
      history.push('/provisioning/settings')
      needReture = true
    } else {
      // if (domain != null && domain.trim().length > 0) {
      try {
        // @todo - 인증처리가 완료되면 domain값을 전달하지 않아도 확인이 가능해짐.
        const domainRes = await mailAdminClient.get('/domains/find', { domain })
        if (domainRes.data != null) {
          domainInfo = domainRes.data
          // id가 domain_id로 변경되어 id의 값이 없으므로, 기존 코드 호환을 위해 id 값을 지정.
          domainInfo.id = domainInfo.id != null ? domainInfo.id : domainInfo.domain_id
        } else {
          // @todo - domain이 없는 경우에는 - Onboarding을 처리하도록 해야 함. (Onboarding page로 이동해야 함.)
          // throw(new Error('Domain info not exist.'));
          if (pathname !== '/provisioning/deleteDomain') {
            history.push('/provisioning/settings')
          }
          needReture = false
        }
      } catch (e) {
        console.log(' - getDomains error : ', e)
        // @todo - domain이 만들어지지 않은 상황은 - 생성 중 오류가 발생한 경우임. - 생성되기 전 상태로 되돌려야 함.
        if (e.message === 'Domain not found') {
          // notification.error({
          //   message: e.code,
          //   description: e.message,
          // })

          if (pathname !== '/provisioning/deleteDomain') {
            history.push('/provisioning/settings')
          }
          needReture = false
        } else {
          reduxStore.dispatch({
            type: 'user/LOGOUT',
          })
          return null
        }
      }
    }

    if (needReture === true) {
      return null
    }
  }

  // onboarding이 완료된 것을 officenote 쪽에 전달하지 못한 상태임.
  if (isOfficenext === true && provisioning !== true && onboarding === false) {
    await updateOnBoarding()
  }

  console.log(' workspaceInfo - ', workspaceInfo)

  const workspace = {
    id: workspaceId,
    gid: workspaceInfo.workspaceGid,
    workspace_name: workspaceInfo.workspaceName,
    workspace_email: workspaceInfo.workspaceEmail,
    icon_url: workspaceInfo.iconUrl,
    role: workspaceInfo.role,
    provider: workspaceInfo.provider,
    enableChat: workspaceInfo.enableChat,
    orgChartType: workspaceInfo.orgChartType,
    allowedDomain,
    domainInfo,
  }

  setEnvParam('provider', workspaceInfo.provider)

  if (workspace.role !== 'admin' && workspace.role !== 'owner') {
    notification.error({
      message: i18n.t('common.title.permission'),
      description: i18n.t('common.warning.permission'),
    })
    reduxStore.dispatch({
      type: 'user/LOGOUT',
    })

    return null
  }

  const appTypeInfo = {
    enableChat: workspaceInfo.enableChat,
    role: workspaceInfo.role,
  }

  setEnvParam('appType', JSON.stringify(appTypeInfo))

  if (workspace.icon_url == null) {
    if (workspace.workspace_name != null) {
      workspace.iconElem = await getInitialAvatar(
        workspace.workspace_name,
        workspace.workspace_email,
      )
    }
  }

  if (myInfo.avatar_url == null) {
    const officeAvatarBlob = await mailApi.getMyProfilePhoto()
    // console.log(' office avatar - ', officeAvatar);
    if (officeAvatarBlob != null) {
      myInfo.avatar_url = window.URL.createObjectURL(officeAvatarBlob)
    }
  }

  const avatarUrl = myInfo.avatar_url != null ? myInfo.avatar_url : ''

  // await loadingCheck()

  return {
    id: myInfo.id,
    name: displayName || '',
    email: myInfo.email,
    // timeFormat: user.mailboxSettings?.timeFormat || '',
    // timeZone: user.mailboxSettings?.timeZone || 'UTC'
    uid: '',
    avatar: avatarUrl,
    role: workspaceInfo.role,
    lastLogin: '',
    workspace,
    provisioning,
  }
}

export async function logout() {
  // return firebaseAuth()
  //   .signOut()
  //   .then(() => true)

  function fakeLogout() {
    store.remove('app.user.provisioning')
    store.remove('app.user.officenext')
    store.remove('app.user.providerToken')
    store.remove('app.user.connection_digest')
    store.remove('app.user.token')
    store.remove('app.user.refreshToken')
    store.remove('app.user.workspace_id')
    store.remove('app.user.deviceUUID')
    // store.remove('app.user.chatInfo')
    // store.remove('app.user.fcmToken')
    // store.remove('app.user.fcmToken_date')
    store.remove('app.user.registorInfo')

    // store.remove('app.user.email')

    // // 사용하지 않는 key 이지만, 이전의 데이터를 지우기 위해 남겨놓음.
    // store.remove('app.user.workspace')

    // // deleteMessagingToken()

    // // stopWS()

    removeEnvParam('provider')
    removeEnvParam('userEmail')
    removeEnvParam('appType')
    dataMgr.clear()

    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(true)
      }, 200)
    })
  }

  return fakeLogout()
}

const apis = {
  // customFetch,
  login,
  logout,
}

export { getWorkspaceInfo }

export default apis
